// src/redux/registerFormReducer.ts
import { getBaseUrl } from '../../Utils'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface ForgotPasswordFormState {
    loading: boolean
    successMessage?: string
    errorMessage?: string
}

export interface ForgotPasswordFormData {
    EmailAddress?: string
}

export interface ForgotPasswordResponse {
    data: any
}

export const forgotPasswordFormAPI = createApi({
    reducerPath: 'forgotpassword', //our reducer lives at store.reducer
    tagTypes: ['RegistrationFormData'],
    baseQuery: fetchBaseQuery({ baseUrl: getBaseUrl() + 'API/v3' }), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        submitForm: build.mutation<ForgotPasswordResponse, Partial<ForgotPasswordFormData>>({
            query: (body) => ({
                url: '/page/forgotpassword',
                method: 'POST',
                body,
            }),
        }),
    }),
})

export const { useSubmitFormMutation } = forgotPasswordFormAPI



